<div mat-dialog-title>
  <span>{{ 'RELEASE.CREATE_NEW_RELEASE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content>
  <form [formGroup]="releaseForm" #form="ngForm" class="form-content">
    <q9-text-field formControlName="name" [label]="'RELEASE.NAME_FIELD'"></q9-text-field>
    <q9-textarea-field
      formControlName="description"
      [minRows]="3"
      [maxRows]="10"
      [label]="'RELEASE.DESCRIPTION_FIELD'"></q9-textarea-field>

    <q9-datetime-picker
      formControlName="targetReleaseDate"
      [label]="'RELEASE.TARGET_RELEASE_DATE'"></q9-datetime-picker>

    <div class="risk-and-type-container">
      <q9-select formControlName="type" [label]="'RELEASE.RELEASE_IMPACT_SELECT'">
        <q9-option *ngFor="let releaseType of releaseTypeList" [value]="releaseType.value">
          <span>{{ releaseType.title }}</span>
        </q9-option>
      </q9-select>

      <q9-select formControlName="riskLevel" [label]="'RELEASE.RELEASE_RISK_SELECT'">
        <q9-option *ngFor="let riskLevel of riskLevelList" [value]="riskLevel.value">
          <span>{{ riskLevel.title }}</span>
        </q9-option>
      </q9-select>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button (click)="switchToVersioning.emit()">
    {{ 'RELEASE.BACK_BTN' | translate }}
  </q9-secondary-button>

  <q9-primary-button [isLoading]="isLoading()" (click)="form.onSubmit($event); onCreateRelease()">
    {{ 'RELEASE.CREATE_RELEASE_BUTTON' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
